import(/* webpackMode: "eager" */ "/vercel/path0/src/app/dashboard/page.js");
